import React, { useState, useEffect, useRef } from 'react';
import './DoctorProfile.css';
import Navbar from '../Navbar/Navbar';
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom"; // Import useNavigate
import '../../assets/css/style.css';
import doctorThumb from '../../assets/img/doctors/doctor-thumb-02.jpg';
import feature01 from '../../assets/img/features/feature-01.jpg';
import feature02 from '../../assets/img/features/feature-02.jpg';
import feature03 from '../../assets/img/features/feature-03.jpg';
import feature04 from '../../assets/img/features/feature-04.jpg';
import speciality05 from '../../assets/img/specialities/specialities-05.png';
import patientImg from '../../assets/img/patients/patient.jpg';
import patientImg1 from '../../assets/img/patients/patient1.jpg';
import patientImg2 from '../../assets/img/patients/patient2.jpg';
import { FaRupeeSign } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faPhone, faClock,faBookmark, faCommentAlt, faVideo } from "@fortawesome/free-solid-svg-icons";
import Footer from '../Footer/Footer';

 const API_BASE_URL = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; // Your backend API URL
    const API_FRONTEND_URL = process.env.API_FRONTEND_URL || 'https://hitkarihospital.com'; // Your backend API URL

// --- Helper function (place this outside your component) ---
const formatTime12Hour = (time24) => {
  if (!time24) return 'N/A';

  const [hours, minutes] = time24.split(':');
  let hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  
  hour = hour % 12;
  hour = hour ? hour : 12; // The hour '0' should be '12'

  return `${hour}:${minutes} ${ampm}`;
};

// Formats a Date object into a 'YYYY-MM-DD' string key
const getFormattedDateKey = (date) => {
    if (!date) return '';
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
};
const DoctorProfile = () => {

    const [activeTab, setActiveTab] = useState('doc_overview');
    const { doctorId } = useParams(); // Get doctorId from URL
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [doctor, setDoctors] = useState([null]);
    const navigate = useNavigate(); // Initialize useNavigate

    useEffect(() => {
        axios.get(`${API_BASE_URL}/api/doctor/${doctorId}`)
            .then(response => {
                setDoctors(response.data); // Store the single doctor object
                setLoading(false);
            })
            .catch(error => {
                setError("Failed to load doctor details");
                setLoading(false);
            });
    }, [doctorId]);

    useEffect(() => {
        axios.get(`${API_BASE_URL}/about/${doctorId}`)
            .then(response => setProfile(response.data))
            .catch(() => setError("Failed to load doctor profile"));
    }, [doctorId]);

    useEffect(() => {
        const fetchDoctorProfile = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/about/${doctorId}`);
                setProfile(response.data);
            } catch (err) {
                setError("Failed to load doctor profile");
            } finally {
                setLoading(false);
            }
        };

        fetchDoctorProfile();
    }, [doctorId]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;
    if (!profile) return <p>No profile found.</p>;

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    const handleBookAppointment = () => {
        // Redirect to the booking page with doctorId
        window.location.href = `${API_FRONTEND_URL}/patientlogin/${doctorId}`;
        // navigate(`/booking/${doctorId}`); // Navigate to the booking page
    };

        // --- NEW LOGIC: Determine today's availability ---
    const todayKey = getFormattedDateKey(new Date());
    // Use today's override if it exists, otherwise fall back to the default schedule.
    // The final `?? []` ensures we always have an array to work with, preventing errors.
    const todaysAvailability = doctor.dateOverrides?.[todayKey] ?? doctor.defaultAvailability ?? [];

    return (
        <>
            <div className="main-wrapper">
                <header className="header">
                    <Navbar />
                </header>

                <div className="breadcrumb-bar">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-md-12 col-12">
                                <nav aria-label="breadcrumb" className="page-breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                                        <li className="breadcrumb-item active" aria-current="page">Doctor Profile</li>
                                    </ol>
                                </nav>
                                <h2 className="breadcrumb-title">Doctor Profile</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content">
                    <div className="container">

                        <div className="card">

                            <div className="card-body">
                                <div className="doctor-widget">
                                    <div className="doc-info-left">
                                        <div className="doctor-img">
                                            <img src={`${API_BASE_URL}/doctor/${doctor.image}`} alt={doctor.name} />
                                        </div>
                                        <div className="doc-info-cont">
                                            <h4 className="doc-name">{doctor.name}</h4>
                                            <p className="doc-speciality"> {doctor.speciality}</p>


                                            <div className="clinic-details">
                                                <p className="doc-location"><FontAwesomeIcon icon={faMapMarkerAlt} /> {doctor.address}</p>
                                                {/* <p className="doc-location"> 🆔 {doctor.doctorId}</p> */}

                                              
 {todaysAvailability.filter(slot => slot.isAvailable).length > 0
                                                        ? todaysAvailability
                                                            .filter(slot => slot.isAvailable)
                                                            .map((slot, idx) => (             // Then, map over the filtered array
            <span key={idx} className="timming" style={{ color: "#757575" }}>
                <FontAwesomeIcon icon={faClock} className="fa-solid fa-clock" style={{ marginRight: "8px", color: "#757575" }} />
               {formatTime12Hour(slot.startTime)} - {formatTime12Hour(slot.endTime)}
            </span>
        ))
    : <span className="timming" style={{ color: "#757575" }}>Doctor Not Available Today</span>
}

                                            </div>

                                        </div>
                                    </div>
                                    <div className="doc-info-right">
                                        <div className="clini-infos">
                                            <ul>

                                                <li><FontAwesomeIcon icon={faMapMarkerAlt} />  {doctor.address}</li>
                                                <li><FaRupeeSign /> {doctor.price} INR </li>
                                            </ul>
                                        </div>

                                        <div className="clinic-booking">
                                            {/* Updated to use handleBookAppointment */}
                                            <a className="apt-btn" onClick={handleBookAppointment}>Book Appointment</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div className="card">
                            <div className="card-body pt-0">


                                <div className="tab-content pt-0">


                                    <div role="tabpanel" id="doc_overview" className={`tab-pane fade ${activeTab === 'doc_overview' ? 'show active' : ''}`}>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-9">


                                                <div className="widget about-widget">
                                                    <h4 className="widget-title">About Me</h4>
                                                    <p>{profile.description || "No description available."}</p>
                                                </div>



                                                <div className="widget education-widget">
                                                    <h4 className="widget-title">Education</h4>
                                                    <div className="experience-box">
                                                        <ul className="experience-list">
                                                            <li>
                                                                <div className="experience-user">
                                                                    <div className="before-circle"></div>
                                                                </div>
                                                                <div className="experience-content">
                                                                    <div className="timeline-content">
                                                                        {profile.education?.length > 0 ? (
                                                                            profile.education.map((edu, index) => (
                                                                                <li key={index}>
                                                                                    <div className="timeline-content">
                                                                                        <a className="name">{edu.university}</a>
                                                                                        <div>{edu.degree}</div>
                                                                                        <span className="time">{edu.year}</span>
                                                                                        <br />
                                                                                    </div>
                                                                                </li>
                                                                            ))
                                                                        ) : (
                                                                            <p>No education details available.</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </li>

                                                        </ul>
                                                    </div>
                                                </div>


                                                <div className="widget experience-widget">
                                                    <h4 className="widget-title">Work & Experience</h4>
                                                    <div className="experience-box">
                                                        <ul className="experience-list">
                                                            <li>
                                                                <div className="experience-user">
                                                                    <div className="before-circle"></div>
                                                                </div>
                                                                <div className="experience-content">
                                                                    <div className="timeline-content">
                                                                        {profile.workExperience?.length > 0 ? (
                                                                            profile.workExperience.map((work, index) => (
                                                                                <li key={index}>
                                                                                    <div className="timeline-content">
                                                                                        <a className="name">{work.workplace}</a>
                                                                                        <span className="time">{work.startYear} - {work.endYear}</span>
                                                                                    </div>
                                                                                    <br />
                                                                                </li>
                                                                            ))
                                                                        ) : (
                                                                            <p>No work experience available.</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </li>


                                                        </ul>
                                                    </div>
                                                </div>


                                                <div className="widget awards-widget">
                                                    <h4 className="widget-title">Awards</h4>
                                                    <div className="experience-box">
                                                        <ul className="experience-list">
                                                            <li>
                                                                <div className="experience-user">
                                                                    <div className="before-circle"></div>
                                                                </div>
                                                                <div className="experience-content">
                                                                    <div className="timeline-content">
                                                                        {profile.awards?.length > 0 ? (
                                                                            profile.awards.map((award, index) => (
                                                                                <li key={index}>
                                                                                    <div className="timeline-content">
                                                                                        <p className="exp-year">{award.month} {award.year}</p>
                                                                                        <h4 className="exp-title">{award.name}</h4>
                                                                                        <p>{award.description}</p>
                                                                                    </div>
                                                                                    <br />
                                                                                </li>
                                                                            ))
                                                                        ) : (
                                                                            <p>No awards available.</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </li>

                                                        </ul>
                                                    </div>
                                                </div>


                                                <div className="service-list">
                                                    <h4>Services</h4>
                                                    <ul className="clearfix">
                                                        {profile.services?.length > 0 ? (
                                                            profile.services.map((service, index) => <li key={index}>{service}</li>)
                                                        ) : (
                                                            <p>No services available.</p>
                                                        )}
                                                    </ul>
                                                </div>


                                                <div className="service-list">
                                                    <h4>Specializations</h4>
                                                    <ul className="clearfix">
                                                        {profile.specialization?.length > 0 ? (
                                                            profile.specialization.map((spec, index) => <li key={index}>{spec}</li>)
                                                        ) : (
                                                            <p>No specializations available.</p>
                                                        )}
                                                    </ul>
                                                </div>


                                            </div>
                                        </div>
                                    </div>


                                    <div role="tabpanel" id="doc_business_hours" className={`tab-pane fade ${activeTab === 'doc_business_hours' ? 'show active' : ''}`}>
                                        <div className="row">
                                            <div className="col-md-6 offset-md-3">


                                                <div className="widget business-widget">
                                                    <div className="widget-content">
                                                        <div className="listing-hours">
                                                            <div className="listing-day current">
                                                                <div className="day">Today <span>5 Nov 2019</span></div>
                                                                <div className="time-items">
                                                                    <span className="open-status"><span className="badge bg-success-light">Open Now</span></span>
                                                                    <span className="time">07:00 AM - 09:00 PM</span>
                                                                </div>
                                                            </div>
                                                            <div className="listing-day">
                                                                <div className="day">Monday</div>
                                                                <div className="time-items">
                                                                    <span className="time">07:00 AM - 09:00 PM</span>
                                                                </div>
                                                            </div>
                                                            <div className="listing-day">
                                                                <div className="day">Tuesday</div>
                                                                <div className="time-items">
                                                                    <span className="time">07:00 AM - 09:00 PM</span>
                                                                </div>
                                                            </div>
                                                            <div className="listing-day">
                                                                <div className="day">Wednesday</div>
                                                                <div className="time-items">
                                                                    <span className="time">07:00 AM - 09:00 PM</span>
                                                                </div>
                                                            </div>
                                                            <div className="listing-day">
                                                                <div className="day">Thursday</div>
                                                                <div class="time-items">
                                                                    <span className="time">07:00 AM - 09:00 PM</span>
                                                                </div>
                                                            </div>
                                                            <div className="listing-day">
                                                                <div className="day">Friday</div>
                                                                <div className="time-items">
                                                                    <span className="time">07:00 AM - 09:00 PM</span>
                                                                </div>
                                                            </div>
                                                            <div className="listing-day">
                                                                <div className="day">Saturday</div>
                                                                <div className="time-items">
                                                                    <span className="time">07:00 AM - 09:00 PM</span>
                                                                </div>
                                                            </div>
                                                            <div className="listing-day closed">
                                                                <div className="day">Sunday</div>
                                                                <div className="time-items">
                                                                    <span className="time"><span className="badge bg-danger-light">Closed</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default DoctorProfile;